import { environment } from '@env';

export const getUserImageLink = (id: string): string => {
  return `${environment.API_URL}public/image/${id}`;
};
